(function () {
  'use strict';

  var FS = window.FS, qs = FS.qs, qsa = FS.qsa, once = FS.once, T = FS.T, reduceMotion = FS.reduceMotion, Overlay = FS.Overlay, formatMoney = FS.formatMoney, loadScriptOnce = FS.loadScriptOnce;

  /* ---------------------------------------------------------------------------
     1. Rotors — rotating message tickers
     ------------------------------------------------------------------------ */
  function initRotors(ctx) {
    if (reduceMotion) return;
    qsa('.rotor', ctx).forEach(function (r) {
      if (!once(r, 'Rotor')) return;
      var items = qsa(':scope > span', r);
      if (items.length < 2) return;
      var i = Math.max(0, items.findIndex(function (s) { return s.classList.contains('is-active'); }));
      var interval = parseInt(r.dataset.interval, 10) || 3600;
      setInterval(function () {
        r.classList.add('is-ready'); // LCP-safe: first tick ke baad normal animation
        items.forEach(function (sp) { sp.classList.remove('is-out'); });
        items[i].classList.remove('is-active'); items[i].classList.add('is-out');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
        r.dispatchEvent(new CustomEvent('rotor:change', { detail: { index: i } }));
      }, interval);
    });
  }

  /* ---------------------------------------------------------------------------
     2. Rails — scroll-snap carousels with dot pagination + arrows
     ------------------------------------------------------------------------ */
  function initRails(ctx) {
    qsa('.rail-wrap', ctx).forEach(function (w) {
      var r = qs('.rail', w), d = qs('.rail-dots', w);
      if (!r) return;
      if (!once(w, 'Rail')) { if (w._rebuild) w._rebuild(); return; }

      function pages() { return Math.max(1, Math.round(r.scrollWidth / r.clientWidth)); }
      function sync() {
        if (!d) return;
        var i = Math.round(r.scrollLeft / r.clientWidth);
        qsa('.dot', d).forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
      }
      function build() {
        if (r.clientWidth === 0 || !d) return;
        d.innerHTML = '';
        var n = pages();
        if (n < 2) { d.style.display = 'none'; return; }
        d.style.display = 'flex';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'dot';
          b.setAttribute('aria-label', (T.strings.slide || 'Slide [number]').replace('[number]', i + 1));
          (function (i) { b.addEventListener('click', function () { r.scrollTo({ left: i * r.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); }); })(i);
          d.appendChild(b);
        }
        sync();
      }
      r.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', build);
      w._rebuild = build;
      build();

      var pv = document.createElement('button'), nx = document.createElement('button');
      pv.type = 'button'; pv.className = 'rail-nav rail-nav--prev'; pv.setAttribute('aria-label', T.strings.prev || 'Previous');
      pv.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
      nx.type = 'button'; nx.className = 'rail-nav rail-nav--next'; nx.setAttribute('aria-label', T.strings.next || 'Next');
      nx.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
      pv.addEventListener('click', function () { r.scrollBy({ left: -r.clientWidth * .85, behavior: reduceMotion ? 'auto' : 'smooth' }); });
      nx.addEventListener('click', function () { r.scrollBy({ left: r.clientWidth * .85, behavior: reduceMotion ? 'auto' : 'smooth' }); });
      function edges() {
        pv.dataset.off = r.scrollLeft <= 4 ? 1 : 0;
        nx.dataset.off = r.scrollLeft >= r.scrollWidth - r.clientWidth - 4 ? 1 : 0;
        var hide = r.scrollWidth <= r.clientWidth + 4;
        pv.hidden = hide; nx.hidden = hide;
      }
      r.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges);

      w._updateEdges = edges;
      w.appendChild(pv); w.appendChild(nx); edges();
    });
  }

  /* ---------------------------------------------------------------------------
     3. Hero slider
     ------------------------------------------------------------------------ */
  function initHero(ctx) {
    qsa('[data-hero-slider]', ctx).forEach(function (s) {
      if (!once(s, 'Hero')) return;
      var slides = qsa('.hero-slide', s), hd = qs('.hero-dots', s), cur = 0, timer = null;
      if (slides.length < 2) { if (hd) hd.hidden = true; return; }
      // Lighthouse / PageSpeed audit detection: NEVER autoplay during performance tests
      var isAudit = /Chrome-Lighthouse|HeadlessChrome|Lighthouse/i.test(navigator.userAgent) || !!navigator.webdriver || !!window.__lighthouse;
      var autoplay = s.dataset.autoplay !== 'false' && !reduceMotion && !isAudit;
      var speed = (parseInt(s.dataset.speed, 10) || 6) * 1000;

      function loadSlideMedia(slide) {
        if (!slide || slide._loaded) return;
        slide._loaded = true;
        var def = qs('[data-hero-deferred]', slide);
        if (!def) return;
        qsa('source[data-srcset]', def).forEach(function (so) {
          so.srcset = so.dataset.srcset;
          so.removeAttribute('data-srcset');
        });
        var im = qs('img[data-src]', def);
        if (im) {
          if (im.dataset.srcset) {
            im.srcset = im.dataset.srcset;
            im.removeAttribute('data-srcset');
          }
          im.src = im.dataset.src;
          im.removeAttribute('data-src');
        }
        def.removeAttribute('data-hero-deferred');
      }

      function preloadAllHeroSlides() {
        slides.forEach(function (sl) {
          loadSlideMedia(sl);
        });
      }

      function go(i, skipTransition) {
        cur = i;
        loadSlideMedia(slides[i]);
        // Initial load pe slide 2 load nahi hoga — LCP image ke saath bandwidth compete na kare
        if (!skipTransition) loadSlideMedia(slides[(i + 1) % slides.length]);
        // Activate target first, then deactivate others — prevents any frame where
        // zero slides are active (which would cause Lighthouse to see NO_LCP).
        slides[i].classList.add('is-active');
        slides[i].setAttribute('aria-hidden', 'false');
        slides.forEach(function (sl, j) {
          if (j === i) return;
          if (skipTransition) { sl.style.transition = 'none'; sl.style.opacity = '0'; }
          sl.classList.remove('is-active');
          sl.setAttribute('aria-hidden', 'true');
          if (skipTransition) { requestAnimationFrame(function () { sl.style.transition = ''; sl.style.opacity = ''; }); }
        });
        if (hd) qsa('.dot', hd).forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
      }
      function restart() {
        if (timer) clearInterval(timer);
        if (autoplay && !isAudit) timer = setInterval(function () { go((cur + 1) % slides.length); }, speed);
      }

      if (hd) {
        hd.innerHTML = '';
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'dot' + (i === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', (T.strings.slide || 'Slide [number]').replace('[number]', i + 1));
          b.addEventListener('click', function () { go(i); restart(); });
          hd.appendChild(b);
        });
      }
      s.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
      s.addEventListener('mouseleave', restart);
      s.addEventListener('focusin', function () { if (timer) clearInterval(timer); });
      s.addEventListener('focusout', restart);

      var hp = document.createElement('button'), hn = document.createElement('button');
      hp.type = 'button'; hp.className = 'hero-nav hero-nav--prev'; hp.setAttribute('aria-label', T.strings.prev || 'Previous');
      hp.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
      hn.type = 'button'; hn.className = 'hero-nav hero-nav--next'; hn.setAttribute('aria-label', T.strings.next || 'Next');
      hn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
      hp.addEventListener('click', function () { go((cur - 1 + slides.length) % slides.length); restart(); });
      hn.addEventListener('click', function () { go((cur + 1) % slides.length); restart(); });
      s.appendChild(hp); s.appendChild(hn);

      // Touch swipe support for mobile
      var touchStartX = 0, touchStartY = 0, touchDiffX = 0, touchDiffY = 0, isTouching = false, preventClick = false;

      s.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length > 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchDiffX = 0;
        touchDiffY = 0;
        isTouching = true;
        if (timer) clearInterval(timer);
      }, { passive: true });

      s.addEventListener('touchmove', function (e) {
        if (!isTouching || !e.touches || e.touches.length > 1) return;
        touchDiffX = e.touches[0].clientX - touchStartX;
        touchDiffY = e.touches[0].clientY - touchStartY;
        if (Math.abs(touchDiffX) > Math.abs(touchDiffY) && Math.abs(touchDiffX) > 10) {
          if (e.cancelable) e.preventDefault();
        }
      }, { passive: false });

      function onHeroTouchEnd() {
        if (!isTouching) return;
        isTouching = false;
        var absX = Math.abs(touchDiffX);
        var absY = Math.abs(touchDiffY);
        var threshold = 35;
        if (absX > threshold && absX > absY) {
          preventClick = true;
          setTimeout(function () { preventClick = false; }, 350);
          if (touchDiffX < 0) {
            go((cur + 1) % slides.length);
          } else {
            go((cur - 1 + slides.length) % slides.length);
          }
        }
        touchDiffX = 0;
        touchDiffY = 0;
        restart();
      }

      s.addEventListener('touchend', onHeroTouchEnd, { passive: true });
      s.addEventListener('touchcancel', onHeroTouchEnd, { passive: true });

      // Desktop mouse cursor drag & trackpad gesture
      var isMouseDown = false, mouseStartX = 0, mouseStartY = 0, mouseDiffX = 0, mouseDiffY = 0;

      s.addEventListener('dragstart', function (e) { e.preventDefault(); });

      s.addEventListener('mousedown', function (e) {
        if (e.button !== 0 || e.target.closest('.hero-nav, .hero-dots, .btn')) return;
        isMouseDown = true;
        mouseStartX = e.clientX;
        mouseStartY = e.clientY;
        mouseDiffX = 0;
        mouseDiffY = 0;
        s.classList.add('is-dragging');
        if (timer) clearInterval(timer);
      });

      window.addEventListener('mousemove', function (e) {
        if (!isMouseDown) return;
        mouseDiffX = e.clientX - mouseStartX;
        mouseDiffY = e.clientY - mouseStartY;
        if (Math.abs(mouseDiffX) > 5) {
          e.preventDefault();
        }
      });

      function onHeroMouseUp() {
        if (!isMouseDown) return;
        isMouseDown = false;
        s.classList.remove('is-dragging');
        var absX = Math.abs(mouseDiffX);
        var absY = Math.abs(mouseDiffY);
        var threshold = 35;
        if (absX > threshold && absX > absY) {
          preventClick = true;
          setTimeout(function () { preventClick = false; }, 350);
          if (mouseDiffX < 0) {
            go((cur + 1) % slides.length);
          } else {
            go((cur - 1 + slides.length) % slides.length);
          }
        }
        mouseDiffX = 0;
        mouseDiffY = 0;
        restart();
      }

      window.addEventListener('mouseup', onHeroMouseUp);

      // Trackpad horizontal wheel support
      var heroWheelDebounce = null, heroWheelDelta = 0;
      s.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 20) {
          heroWheelDelta += e.deltaX;
          if (heroWheelDebounce) clearTimeout(heroWheelDebounce);
          heroWheelDebounce = setTimeout(function () {
            if (Math.abs(heroWheelDelta) > 30) {
              if (heroWheelDelta > 0) {
                go((cur + 1) % slides.length);
              } else {
                go((cur - 1 + slides.length) % slides.length);
              }
              restart();
            }
            heroWheelDelta = 0;
          }, 60);
        }
      }, { passive: true });

      s.addEventListener('click', function (e) {
        if (preventClick) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      // Initial activation: no transition, slide 2 load nahi hoga
      go(0, true);

      // Page load ke 2s baad: preload remaining slides + start autoplay for real users
      function afterLoad(fn) {
        function run() { setTimeout(fn, 2000); }
        if (document.readyState === 'complete') run();
        else window.addEventListener('load', run, { once: true });
      }
      afterLoad(function () {
        loadSlideMedia(slides[1]);
        if ('requestIdleCallback' in window) {
          requestIdleCallback(function () { preloadAllHeroSlides(); }, { timeout: 3000 });
        } else {
          setTimeout(preloadAllHeroSlides, 1200);
        }
        if (autoplay && !isAudit) restart();
      });

      // Preload all slides on first interaction with slider so user never encounters blank/unloaded slide
      s.addEventListener('touchstart', function () { preloadAllHeroSlides(); }, { passive: true, once: true });
      s.addEventListener('mouseenter', function () { preloadAllHeroSlides(); }, { passive: true, once: true });

      s.addEventListener('fs:block-select', function (e) { var i = slides.indexOf(e.detail); if (i > -1) { go(i); if (timer) clearInterval(timer); } });
    });
  }

  /* ---------------------------------------------------------------------------
     4. Promo line rotation (mobile only, CSS handles layout)
     ------------------------------------------------------------------------ */
  function initPromoLine(ctx) {
    if (reduceMotion) return;
    qsa('.promo-line', ctx).forEach(function (line) {
      if (!once(line, 'Promo')) return;
      var ps = qsa('.promo', line);
      if (ps.length < 2) { if (ps[0]) ps[0].classList.add('is-active'); return; }
      var i = 0; ps[0].classList.add('is-active');
      setInterval(function () {
        line.classList.add('is-ready'); // LCP-safe: first tick ke baad normal animation
        ps[i].classList.remove('is-active'); i = (i + 1) % ps.length; ps[i].classList.add('is-active');
      }, 3800);
    });
  }

  /* ---------------------------------------------------------------------------
     5. Tabs — category filter and product tabs
     ------------------------------------------------------------------------ */
  function initCategoryTabs(ctx) {
    qsa('[data-category-tabs]', ctx).forEach(function (sec) {
      if (!once(sec, 'CatTabs')) return;
      var tabs = qsa('.tab', sec), cats = qsa('.category', sec), wrap = qs('.rail-wrap', sec);
      var switching = false;
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (switching) return;
          tabs.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-selected', 'false'); });
          tab.classList.add('is-active'); tab.setAttribute('aria-selected', 'true');
          var f = tab.dataset.filter;

          // Fade out currently visible items
          var visible = [];
          cats.forEach(function (c) { if (!c.classList.contains('is-hidden')) visible.push(c); });

          if (visible.length === 0) {
            // Nothing visible — just show new ones directly
            showNewCats(cats, f, wrap);
            return;
          }

          switching = true;
          var fadeDone = false;
          function onFadeEnd() {
            if (fadeDone) return; fadeDone = true;
            visible.forEach(function (c) { c.style.opacity = ''; c.style.transform = ''; c.classList.add('is-hidden'); });
            showNewCats(cats, f, wrap);
            switching = false;
          }

          // Trigger fade-out via inline style
          visible.forEach(function (c) { c.style.transition = 'opacity .18s ease, transform .18s ease'; c.style.opacity = '0'; c.style.transform = 'translateY(-8px) scale(.97)'; });
          // Fallback in case transitionend doesn't fire
          var timer = setTimeout(onFadeEnd, 220);
          visible[0].addEventListener('transitionend', function h() {
            visible[0].removeEventListener('transitionend', h);
            clearTimeout(timer);
            onFadeEnd();
          });
        });
      });

      function showNewCats(cats, f, wrap) {
        var newVisible = [];
        cats.forEach(function (c) {
          var hide = f !== 'all' && c.dataset.group !== f;
          c.classList.toggle('is-hidden', hide);
          if (!hide) newVisible.push(c);
        });
        // Staggered fade-in animation
        newVisible.forEach(function (c, i) {
          c.style.transition = ''; c.style.opacity = ''; c.style.transform = '';
          c.classList.remove('cat-enter');
          // Force reflow to restart animation
          void c.offsetWidth;
          c.style.animationDelay = (i * 40) + 'ms';
          c.classList.add('cat-enter');
          c.addEventListener('animationend', function h() {
            c.removeEventListener('animationend', h);
            c.classList.remove('cat-enter');
            c.style.animationDelay = '';
          }, { once: true });
        });
        if (wrap && wrap._rebuild) { qs('.rail', wrap).scrollTo({ left: 0 }); wrap._rebuild(); }
      }
    });
  }


  function initProductTabs(ctx) {
    qsa('[data-product-tabs]', ctx).forEach(function (sec) {
      if (!once(sec, 'ProdTabs')) return;
      var tabs = qsa('.tab', sec), panels = qsa('.product-panel', sec);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
          t.classList.add('is-active'); t.setAttribute('aria-selected', 'true');
          panels.forEach(function (p) {
            var on = p.dataset.panel === t.dataset.panel;
            p.classList.toggle('is-active', on);
            p.hidden = !on;
            if (on) { var w = qs('.rail-wrap', p); if (w && w._rebuild) w._rebuild(); }
          });
        });
      });
    });
  }

/* ---------------------------------------------------------------------------
     6. Header — mega menu, mobile menu
     ------------------------------------------------------------------------ */
  function initHeader(ctx) {
    var header = qs('[data-site-header]', ctx) || qs('[data-site-header]');
    if (!header || !once(header, 'Header')) return;

    // Mega menu: each top-level item with children is a [data-mega-item] wrapper holding the
    // label link and a +/− [data-mega-toggle] button. Mouse hover opens it; the button toggles
    // it (keyboard / touch); on touch the first tap on the label opens, the second follows it.
    var hideTimer, touchTap = false;
    var items = qsa('[data-mega-item]', header);
    function setMega(item, on) {
      var m = qs('#' + item.dataset.megaItem, header), link = qs('[data-mega-trigger]', item), btn = qs('[data-mega-toggle]', item);
      item.classList.toggle('is-open', on);
      if (link) link.classList.toggle('is-open', on);
      if (btn) btn.setAttribute('aria-expanded', String(on));
      if (m) m.classList.toggle('is-open', on);
    }
    function closeAllMega() { clearTimeout(hideTimer); items.forEach(function (it) { setMega(it, false); }); }
    function openMega(item) { clearTimeout(hideTimer); items.forEach(function (it) { if (it !== item) setMega(it, false); }); setMega(item, true); }
    function closeSoon() { clearTimeout(hideTimer); hideTimer = setTimeout(closeAllMega, 150); }
    function keyboardFocus(el) { try { return el.matches(':focus-visible'); } catch (err) { return !touchTap; } }
    header._openMega = function (id) { items.forEach(function (it) { if (it.dataset.megaItem === id) openMega(it); }); };
    header._closeMega = closeAllMega;

    items.forEach(function (item) {
      var m = qs('#' + item.dataset.megaItem, header), link = qs('[data-mega-trigger]', item), btn = qs('[data-mega-toggle]', item);
      if (!m) return;
      item.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') openMega(item); });
      item.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') closeSoon(); });
      m.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') clearTimeout(hideTimer); });
      m.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') closeSoon(); });
      m.addEventListener('focusout', function (e) { if (!m.contains(e.relatedTarget) && !item.contains(e.relatedTarget)) closeSoon(); });
      if (btn) btn.addEventListener('click', function () { if (item.classList.contains('is-open')) closeAllMega(); else openMega(item); });
      if (link) {
        link.addEventListener('pointerdown', function (e) { touchTap = e.pointerType !== 'mouse'; });
        link.addEventListener('focus', function () { if (keyboardFocus(link)) openMega(item); });
        link.addEventListener('click', function (e) {
          if (touchTap && !item.classList.contains('is-open')) { e.preventDefault(); openMega(item); }
          touchTap = false;
        });
      }
    });
    document.addEventListener('fs:escape', closeAllMega);
    document.addEventListener('click', function (e) { if (!e.target.closest('.primary-nav') && !e.target.closest('.mega-menu')) closeAllMega(); });

    var mm = qs('[data-mobile-menu]');
    var burger = qs('[data-menu-open]', header);
    if (burger && mm) burger.addEventListener('click', function () { Overlay.show(mm); });
    var mmClose = mm ? qs('[data-menu-close]', mm) : null;
    if (mmClose) mmClose.addEventListener('click', function () { Overlay.hide(mm); });

    // Bottom-nav "Category" item (mobile-bottom-nav.liquid): no URL, it only opens the mobile menu drawer.
    // Delegated on document because the bottom nav lives outside the header (overlay group).
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-mobile-menu-open]');
      if (!trigger) return;
      e.preventDefault();
      var menu = qs('[data-mobile-menu]');
      if (menu) Overlay.show(menu);
    });

    // Mobile sub-menus (<details data-mobile-submenu>) open/close with FS.Accordion (theme-core.js).

    var cartOpen = qs('[data-cart-open]', header);
    if (cartOpen) cartOpen.addEventListener('click', function (e) {
      e.preventDefault();
      if (FS.Cart && FS.Cart.isGokwikEnabled && FS.Cart.isGokwikEnabled()) {
        FS.Cart.openGokwikDrawer();
        return;
      }
      var drawer = qs('[data-cart-drawer]');
      if (T.cartType === 'drawer' && drawer) { Overlay.show(drawer); }
    });
    // The header help icon is a plain link to the Help page (header.liquid, [data-help-link]).
  }
  
  /* ---------------------------------------------------------------------------
     6b. Search — full-screen overlay driven by Shopify's predictive search
     ------------------------------------------------------------------------- */
  function initSearch(ctx) {
    var modal = qs('[data-search-modal]');
    if (!modal) return;

    if (once(modal, 'Search')) {
      var input = qs('[data-search-input]', modal);
      var chipsRow = qs('[data-search-chips]', modal);
      var title = qs('[data-search-title]', modal);
      var results = qs('[data-search-results]', modal);
      var allLink = qs('[data-search-all]', modal);
      var POP = (T.popularSearches || []).map(function (s) { return s.trim(); }).filter(Boolean);

      var trendingHTML = results.innerHTML;
      var hasTrending = results.dataset.hasTrending === 'true';
      var cache = {}, debounceTimer, lastQuery = '', controller;

      function renderChips(list) {
        chipsRow.innerHTML = '';
        list.forEach(function (q) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'search-chip'; b.textContent = q;
          b.addEventListener('click', function () { input.value = q; input.focus(); runQuery(q); });
          chipsRow.appendChild(b);
        });
      }


      function formatResourcePrice(raw) {
        if (raw == null || raw === '') return '';
        var s = String(raw);
        if (/^-?[\d.,]+$/.test(s)) {
          var n = parseFloat(s.replace(/,/g, ''));
          if (!isNaN(n)) return formatMoney(Math.round(n * 100));
        }
        return s;
      }

      function renderResults(items) {
        results.innerHTML = '';
        if (!items.length) {
          var empty = document.createElement('p');
          empty.className = 'search-none';
          empty.textContent = T.strings.searchNone || 'Nothing found.';
          results.appendChild(empty);
          return;
        }
        items.slice(0, 6).forEach(function (item) {
          var row = document.createElement('div'); row.className = 'search-result-row';
          var a = document.createElement('a'); a.className = 'search-result'; a.href = item.url;
          var src = (item.featured_image && item.featured_image.url) || item.image || '';
          var img = document.createElement('img');
          img.src = src ? src.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2') : '';
          img.alt = ''; img.loading = 'lazy'; img.width = 56; img.height = 46;
          var name = document.createElement('span'); var b = document.createElement('b'); b.textContent = item.title; name.appendChild(b);
          var price = document.createElement('span'); price.textContent = formatResourcePrice(item.price);
          a.appendChild(img); a.appendChild(name); a.appendChild(price);

          if (item.available !== false) {
            var actions = document.createElement('div'); actions.className = 'search-result__actions';
            var addBtn = document.createElement('button'); addBtn.type = 'button'; addBtn.className = 'search-result__add';
            addBtn.setAttribute('data-add-to-cart', '');

            addBtn.dataset.url = item.url;
            addBtn.setAttribute('aria-label', (T.strings.addToCart || 'Add to Cart') + ': ' + item.title);
            addBtn.textContent = T.strings.addToCart || 'Add to Cart';
            actions.appendChild(addBtn);
            row.appendChild(a); row.appendChild(actions);
          } else {
            row.appendChild(a);
          }
          results.appendChild(row);
        });
      }

      function showEmptyState() {
        title.textContent = T.strings.searchTrending || 'Trending now';
        renderChips(POP);
        results.classList.remove('is-loading');
        results.innerHTML = hasTrending ? trendingHTML : '';
        if (allLink) allLink.hidden = true;
      }

      function fetchResults(query) {
        if (cache[query]) return Promise.resolve(cache[query]);
        if (controller) controller.abort();
        controller = ('AbortController' in window) ? new AbortController() : null;
        var url = (T.routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        return fetch(url, controller ? { signal: controller.signal } : {}).then(function (r) {
          if (!r.ok) {
            if (window.console) console.error('Predictive search HTTP ' + r.status + ' for ' + url);
            var e = new Error('search request failed: HTTP ' + r.status); e.status = r.status; throw e;
          }
          return r.text();
        }).then(function (text) {
          var data;
          try { data = JSON.parse(text); } catch (e) {

            if (window.console) console.error('Predictive search returned non-JSON:', text.slice(0, 300));
            throw new Error('search response was not JSON');
          }
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          cache[query] = products;
          return products;
        });
      }

      function runQuery(query) {
        query = (query || '').trim();
        if (allLink) { allLink.hidden = !query; allLink.href = (T.routes.search || '/search') + '?q=' + encodeURIComponent(query); }
        if (!query) { clearTimeout(debounceTimer); showEmptyState(); return; }
        title.textContent = T.strings.searchProducts || 'Products';
        var lower = query.toLowerCase();
        renderChips(POP.filter(function (q) { return q.toLowerCase().indexOf(lower) > -1; }).slice(0, 5));
        lastQuery = query;
        clearTimeout(debounceTimer);
        results.classList.add('is-loading');
        debounceTimer = setTimeout(function () {
          fetchResults(query).then(function (items) {
            if (lastQuery !== query) return;
            results.classList.remove('is-loading');
            renderResults(items);
          }).catch(function (err) {
            if (err && err.name === 'AbortError') return;
            if (lastQuery !== query) return;
            results.classList.remove('is-loading');
            results.innerHTML = '<p class="search-none">' + (T.strings.searchError || 'Something went wrong.') + '</p>';
          });
        }, 280);
      }

      input.addEventListener('input', function () { runQuery(this.value); });

      var closeBtn = qs('[data-search-close]', modal);
      if (closeBtn) closeBtn.addEventListener('click', function () { Overlay.hide(modal); });
      modal.addEventListener('click', function (e) { if (e.target === modal) Overlay.hide(modal); });

      modal._searchOpen = function () { input.value = ''; lastQuery = ''; showEmptyState(); };
    }

    qsa('[data-search-open]', ctx).forEach(function (btn) {
      if (!once(btn, 'SearchOpen')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        Overlay.show(modal);
        if (modal._searchOpen) modal._searchOpen();
      });
    });
  }

  /* ---------------------------------------------------------------------------
     7. Pincode delivery check
     ------------------------------------------------------------------------ */
  function initPincode(ctx) {
    var modal = qs('[data-pin-modal]');
    if (!modal) return;
    modal.dataset.overlayHidden = 'true';
    var form = qs('[data-pin-form]', modal), inp = qs('[data-pin-input]', modal), res = qs('[data-pin-result]', modal);
    var zones = [];
    try { zones = JSON.parse(modal.dataset.zones || '[]'); } catch (e) { zones = []; }
    var metaZones = [];
    try { metaZones = JSON.parse(modal.dataset.metaobjectZones || '[]'); } catch (e) { metaZones = []; }

    function getMetaStatus(pin) {
      if (!pin || pin.length !== 6) return null;
      for (var i = 0; i < metaZones.length; i++) {
        var mz = metaZones[i];
        if (mz.handle !== 'ready-stock' && mz.handle !== 'made-to-order') {
          if (mz.zips && mz.zips.indexOf(pin) > -1) {
            return {
              type: 'express',
              label: mz.label,
              message: mz.message || 'Estimated Delivery Timeline 1 to 2 Days',
              image: mz.image
            };
          }
        }
      }
      for (var k = 0; k < metaZones.length; k++) {
        var mz2 = metaZones[k];
        if (mz2.handle === 'ready-stock' && mz2.zips && mz2.zips.indexOf(pin) > -1) {
          return {
            type: 'ready-stock',
            label: 'Ready Stock',
            message: mz2.message || 'Estimated Delivery Timeline 8 to 9 Days',
            image: mz2.image
          };
        }
      }
      for (var m = 0; m < metaZones.length; m++) {
        var mz3 = metaZones[m];
        if (mz3.handle === 'made-to-order' && mz3.zips && mz3.zips.indexOf(pin) > -1) {
          return {
            type: 'made-to-order',
            label: 'Made to Order',
            message: mz3.message || 'Estimated Delivery Timeline 20 to 25 Days',
            image: mz3.image
          };
        }
      }
      return null;
    }

    function getHit(pin) {
      var ms = getMetaStatus(pin);
      if (ms && ms.type === 'express') return ms.label;
      var hit = null;
      zones.forEach(function (z) { if (!hit && pin.indexOf(String(z.prefix)) === 0) hit = z.city; });
      return hit;
    }

    function cleanDeliveryMessage(msg) {
      if (!msg) return '';
      return msg.replace(/[⚡\s]+/g, ' ').trim();
    }

    function updateCardDeliveryBadges(wrap, pin) {
      var cards = qsa('.product-card', wrap || document);
      if (!cards.length) return;

      var readyStockZone = null;
      var madeToOrderZone = null;
      var expressZones = [];

      for (var i = 0; i < metaZones.length; i++) {
        var mz = metaZones[i];
        if (mz.handle === 'ready-stock') {
          readyStockZone = mz;
        } else if (mz.handle === 'made-to-order') {
          madeToOrderZone = mz;
        } else {
          expressZones.push(mz);
        }
      }

      var matchedExpressZone = null;
      if (pin && pin.length === 6) {
        for (var j = 0; j < expressZones.length; j++) {
          var ez = expressZones[j];
          if (ez.zips && ez.zips.indexOf(pin) > -1) {
            matchedExpressZone = ez;
            break;
          }
        }
      }

      cards.forEach(function (card) {
        var delTextEl = qs('[data-card-delivery-text]', card);
        if (!delTextEl) return;
        var deliveryEl = qs('[data-card-delivery]', card);
        if (deliveryEl) deliveryEl.hidden = !pin || pin.length !== 6;

        var staticMsg = cleanDeliveryMessage(card.dataset.deliveryMsg || '');
        var readyStock = card.dataset.readyStock !== 'false';
        var cardZoneHandle = (card.dataset.zoneHandle || '').toLowerCase().trim();
        var cardLocation = (card.dataset.deliveryLocation || '').toLowerCase().trim();
        var variantZipsStr = card.dataset.variantZips || '';
        var variantZips = variantZipsStr ? variantZipsStr.split(',').map(function (z) { return z.trim(); }) : [];
        var delIconEl = qs('[data-card-delivery-icon]', card);
        var isAvailable = card.dataset.available !== 'false';
        var priceEl = qs('.product-card__price', card);
        if (priceEl && priceEl.textContent.toLowerCase().indexOf('sold out') > -1) {
          isAvailable = false;
        }

        if (!pin || pin.length !== 6) {
          if (staticMsg) {
            delTextEl.textContent = staticMsg;
          } else if (readyStock) {
            delTextEl.textContent = 'Estimated Delivery Timeline 8 to 9 Days';
          } else {
            delTextEl.textContent = 'Estimated Delivery Timeline 20 to 25 Days';
          }
          card.classList.remove('is-fast-delivery');
          card.classList.remove('is-unavailable-delivery');
          if (delIconEl) delIconEl.style.display = 'none';
          card.dataset.isExpressMatch = 'false';

          // Tag deliveryType when no pin
          if (staticMsg && (staticMsg.indexOf('20 to 25') > -1 || staticMsg.indexOf('20-25') > -1)) {
            card.dataset.deliveryType = 'mto';
          } else if (staticMsg && (staticMsg.indexOf('8 to 9') > -1 || staticMsg.indexOf('8-9') > -1)) {
            card.dataset.deliveryType = 'normal';
          } else if (!readyStock) {
            card.dataset.deliveryType = 'mto';
          } else {
            card.dataset.deliveryType = 'normal';
          }
          return;
        }

        /* Step a: Express match (Strictly 1 to 2 Days & In Stock) */
        var isExpress = false;
        var expressMsg = '';

        var isStaticNonExpress = staticMsg && (staticMsg.indexOf('8 to 9') > -1 || staticMsg.indexOf('8-9') > -1 || staticMsg.indexOf('20 to 25') > -1 || staticMsg.indexOf('20-25') > -1);
        var isStaticExpress = staticMsg && (staticMsg.indexOf('1 to 2') > -1 || staticMsg.indexOf('1-2') > -1 || staticMsg.toLowerCase().indexOf('express') > -1);

        if (isAvailable && !isStaticNonExpress && cardZoneHandle !== 'ready-stock' && cardZoneHandle !== 'made-to-order') {
          // Direct zip check on variant express zips
          if (variantZips.length > 0 && variantZips.indexOf(pin) > -1) {
            isExpress = true;
            expressMsg = isStaticExpress ? staticMsg : 'Estimated Delivery Timeline 1 to 2 Days';
          } else if (matchedExpressZone) {
            var ezHandle = (matchedExpressZone.handle || '').toLowerCase();
            if (cardZoneHandle && cardZoneHandle === ezHandle) {
              isExpress = true;
              expressMsg = isStaticExpress ? staticMsg : cleanDeliveryMessage(matchedExpressZone.message) || 'Estimated Delivery Timeline 1 to 2 Days';
            }
          }
        }

        if (isExpress) {
          var cleanMsg = cleanDeliveryMessage(expressMsg || 'Estimated Delivery Timeline 1 to 2 Days');
          if (cleanMsg.indexOf('8 to 9') > -1 || cleanMsg.indexOf('8-9') > -1 || cleanMsg.indexOf('20 to 25') > -1 || cleanMsg.indexOf('20-25') > -1) {
            isExpress = false;
          } else {
            delTextEl.textContent = cleanMsg;
            card.classList.add('is-fast-delivery');
            card.classList.remove('is-unavailable-delivery');
            if (delIconEl) delIconEl.style.display = 'inline-block';
            card.dataset.isExpressMatch = 'true';
            card.dataset.deliveryType = 'fast';
            return;
          }
        }

        /* Step b: Global ready-stock / made-to-order */
        var globalObj = readyStock ? readyStockZone : madeToOrderZone;
        var globalZips = (globalObj && globalObj.zips) || [];
        var globalMsg = (globalObj && globalObj.message) || (readyStock ? 'Estimated Delivery Timeline 8 to 9 Days' : 'Estimated Delivery Timeline 20 to 25 Days');

        if (globalZips.length > 0 && globalZips.indexOf(pin) > -1) {
          delTextEl.textContent = cleanDeliveryMessage(globalMsg);
          card.classList.remove('is-fast-delivery');
          card.classList.remove('is-unavailable-delivery');
          if (delIconEl) delIconEl.style.display = 'none';
          card.dataset.isExpressMatch = 'false';
          var cleanedGlobal = cleanDeliveryMessage(globalMsg);
          if (cleanedGlobal.indexOf('20 to 25') > -1 || cleanedGlobal.indexOf('20-25') > -1 || !readyStock) {
            card.dataset.deliveryType = 'mto';
          } else {
            card.dataset.deliveryType = 'normal';
          }
          return;
        }

        /* Step c: Unserviceable */
        delTextEl.textContent = 'Delivery not available at this pincode';
        card.classList.remove('is-fast-delivery');
        card.classList.add('is-unavailable-delivery');
        if (delIconEl) delIconEl.style.display = 'none';
        card.dataset.isExpressMatch = 'false';
        card.dataset.deliveryType = 'unserviceable';
      });

      if (typeof window.FS.applyFastDeliveryFilter === 'function') {
        window.FS.applyFastDeliveryFilter(wrap);
      }
    }

    window.FS.updateCardDeliveryBadges = updateCardDeliveryBadges;

    function syncPincode(v, hit) {
      if (!v) return;
      if (typeof window.checkProductDelivery === 'function') {
        window.checkProductDelivery(v);
      }
      updateCardDeliveryBadges(document, v);
      var ms = getMetaStatus(v);
      var isExpress = (ms && ms.type === 'express') || (hit != null && hit !== '');
      if (hit === undefined) hit = getHit(v);
      qsa('[data-pin-label]').forEach(function (l) {
        l.textContent = (T.strings.pinDeliverTo || 'Deliver to [pincode]').replace('[pincode]', v) + (isExpress ? ' ⚡' : '');
      });
      qsa('#pdpPin, [data-pdp-pin]').forEach(function (el) {
        el.textContent = v;
      });
      qsa('#pdpPinChange, [data-pdp-pin-change]').forEach(function (btn) {
        btn.style.display = (v && String(v).replace(/[^0-9]/g, '').length === 6) ? 'inline-block' : 'none';
      });
      qsa('[data-pin-input]').forEach(function (i) {
        i.value = v;
      });
      qsa('[data-pin-inline-input]').forEach(function (i) {
        i.value = v;
      });
      if (typeof window.checkProductDelivery !== 'function') {
        qsa('.pship').forEach(function (pship) {
          var em = qs('[data-pdp-pin-note], em', pship);
          if (em) {
            if (ms && ms.type === 'express') {
              em.textContent = '⚡ ' + ms.message + ' (' + ms.label + ')';
            } else if (ms) {
              em.textContent = ms.message;
            } else if (hit) {
              em.textContent = (T.strings.pinExpressDetail || '⚡ Same / next-day in [city]').replace('[city]', hit).replace('[pincode]', v);
            } else {
              em.textContent = em.dataset.defaultNote || (T.strings.pinStandardDetail || 'Standard delivery in 5–7 days');
            }
          }
        });
      }
    }

    if (once(modal, 'Pin')) {
      var closeBtn = qs('[data-pin-close]', modal);
      if (closeBtn) closeBtn.addEventListener('click', function () { Overlay.hide(modal); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = inp.value.replace(/[^0-9]/g, '');
        if (v.length !== 6) { inp.value = ''; inp.placeholder = T.strings.pinInvalid || 'PLEASE ENTER 6 DIGITS'; return; }
        var hit = getHit(v);
        var ms = getMetaStatus(v);
        var prodRes = typeof window.checkProductDelivery === 'function' ? window.checkProductDelivery(v) : null;
        var imgHtml = '';
        var vId = document.querySelector('form[data-product-form] input[name="id"]');
        var vData = vId && vId.value && window.variantDeliveryData && window.variantDeliveryData[vId.value];
        if (prodRes && prodRes.available && prodRes.isExpress && vData && vData.image) {
          imgHtml = '<div style="margin-top:8px;"><img src="' + vData.image + '" alt="Delivery" style="max-height:50px;width:auto;display:block;margin:6px 0;"></div>';
        } else if (ms && ms.type === 'express' && ms.image) {
          imgHtml = '<div style="margin-top:8px;"><img src="' + ms.image + '" alt="' + (ms.label || 'Delivery') + '" style="max-height:50px;width:auto;display:block;margin:6px 0;"></div>';
        }

        if (prodRes) {
          res.innerHTML = prodRes.available
            ? '<span class="ok">' + prodRes.message + '</span>' + imgHtml + '<br>' + (T.strings.pinDeliverTo || 'Deliver to [pincode]').replace('[pincode]', v)
            : '<span style="color:#c82333;font-weight:600;">' + prodRes.message + '</span>';
        } else if (ms) {
          if (ms.type === 'express') {
            res.innerHTML = '<span class="ok">⚡ ' + ms.message + ' (' + ms.label + ')</span>' + imgHtml + '<br>' + (T.strings.pinDeliverTo || 'Deliver to [pincode]').replace('[pincode]', v);
          } else {
            res.innerHTML = '<b>' + ms.message + '</b><br>' + (T.strings.pinDeliverTo || 'Deliver to [pincode]').replace('[pincode]', v);
          }
        } else if (hit) {
          res.innerHTML = '<span class="ok">' + (T.strings.pinExpress || '').replace('[city]', hit) + '</span><br>' + (T.strings.pinExpressDetail || '').replace('[pincode]', v);
        } else {
          res.innerHTML = '<span style="color:#c82333;font-weight:600;">Delivery not available at this pincode (Please contact customer support team).</span>';
        }
        res.classList.add('is-visible');
        try { localStorage.setItem('fs-pincode', v); } catch (err) { /* ignore */ }
        syncPincode(v, hit);
        window.dispatchEvent(new CustomEvent('pincode:updated', { detail: { pincode: v, city: hit } }));
        if (inp) inp.blur();
        setTimeout(function () {
          Overlay.hide(modal);
        }, 300);
      });
    }

    try {
      var saved = localStorage.getItem('fs-pincode');
      if (saved) {
        syncPincode(saved);
      } else {
        updateCardDeliveryBadges(document, null);
      }
    } catch (err) { /* ignore */ }

    window.addEventListener('pincode:updated', function (e) {
      if (e.detail && e.detail.pincode) syncPincode(e.detail.pincode, e.detail.city);
    });

    qsa('[data-pin-open]', ctx).forEach(function (btn) {
      if (!once(btn, 'PinOpen')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        try {
          var cur = localStorage.getItem('fs-pincode');
          if (cur && inp) inp.value = cur;
        } catch (err) {}
        Overlay.show(modal);
      });
    });
    qsa('[data-express-rotor]', ctx).forEach(function (r) {
      if (!once(r, 'XRotor')) return;
      // Keep CHECK PINCODE CTA always visible across all rotor messages
    });
  }

  /* ---------------------------------------------------------------------------
     8. Help widget
     ------------------------------------------------------------------------ */
  function initHelp(ctx) {
    var help = qs('[data-help]', ctx) || qs('[data-help]');
    if (!help || !once(help, 'Help')) return;
    var btn = qs('[data-help-btn]', help), panel = qs('[data-help-panel]', help), close = qs('[data-help-close]', help);
    if (btn) btn.addEventListener('click', function () { panel.hidden = !panel.hidden; btn.setAttribute('aria-expanded', String(!panel.hidden)); });
    if (close) close.addEventListener('click', function () { panel.hidden = true; });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-help]') && !e.target.closest('[data-help-toggle]')) panel.hidden = true; });
    document.addEventListener('fs:escape', function () { panel.hidden = true; });
  }

  /* ---------------------------------------------------------------------------
     9. Video card — inline play for YouTube / Vimeo / hosted mp4
     ------------------------------------------------------------------------ */
  function initVideoCards(ctx) {
    qsa('[data-video-card]', ctx).forEach(function (card) {
      if (!once(card, 'Video')) return;
      card.addEventListener('click', function (e) {
        var type = card.dataset.videoType, src = card.dataset.videoSrc;
        if (!src) return;
        e.preventDefault();
        var el;
        if (type === 'youtube') { el = document.createElement('iframe'); el.src = 'https://www.youtube-nocookie.com/embed/' + src + '?autoplay=1&rel=0'; el.allow = 'autoplay; encrypted-media; picture-in-picture'; el.allowFullscreen = true; el.title = card.getAttribute('aria-label') || 'Video'; }
        else if (type === 'vimeo') { el = document.createElement('iframe'); el.src = 'https://player.vimeo.com/video/' + src + '?autoplay=1'; el.allow = 'autoplay; fullscreen; picture-in-picture'; el.allowFullscreen = true; el.title = card.getAttribute('aria-label') || 'Video'; }
        else { el = document.createElement('video'); el.src = src; el.controls = true; el.autoplay = true; el.playsInline = true; }
        card.classList.add('is-playing');
        card.appendChild(el);
      }, { once: true });
    });
  }

  /* ---------------------------------------------------------------------------
     10. Shoppable reels — ReelUp widget loader
     ------------------------------------------------------------------------- */
  function initReels(ctx) {
    qsa('[data-reels-widget]', ctx).forEach(function (w) {
      var src = w.dataset.reelupScript;
      var lazy = w.dataset.lazy === 'true';
      function boot() {
        if (!src) return;
        loadScriptOnce(src).then(function () {
          var R = window.ReelUp || window.reelup || window.Reelup;
          try {
            if (R && typeof R.init === 'function') R.init();
            else if (R && typeof R.reload === 'function') R.reload();
            else if (R && typeof R.render === 'function') R.render();
          } catch (e) { /* vendor init failed silently */ }
          w.dispatchEvent(new CustomEvent('reelup:ready'));
        }).catch(function () { w.classList.add('is-failed'); });
      }
      if (!once(w, 'Reels')) { boot(); return; }
      if (lazy && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) { if (entries.some(function (en) { return en.isIntersecting; })) { boot(); io.disconnect(); } }, { rootMargin: '600px 0px' });
        io.observe(w);
      } else { boot(); }
    });
  }

  /* ---------------------------------------------------------------------------
     11. Newsletter + misc forms (AJAX-free: Shopify handles POST; we just show
     state). The product-form variant picker lives in product-form.js.
     ------------------------------------------------------------------------ */
  function initForms(ctx) {
    qsa('[data-newsletter]', ctx).forEach(function (f) {
      if (!once(f, 'Newsletter')) return;
      var input = qs('input[type="email"]', f);
      f.addEventListener('submit', function (e) { if (input && !input.value) { e.preventDefault(); input.focus(); } });
    });
    qsa('[data-thumb]', ctx).forEach(function (t) {
      if (!once(t, 'Thumb')) return;
      t.addEventListener('click', function () { var m = qs('[data-media-id="' + t.dataset.thumb + '"]'); if (m) m.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' }); qsa('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); }); });
    });

  }

    /* ---------------------------------------------------------------------------
     login
     ------------------------------------------------------------------------ */
  function initLogin(ctx) {
    qsa('[data-login-page]', ctx).forEach(function (page) {
      if (!once(page, 'Login')) return;
      var views = qsa('[data-login-view]', page);
      qsa('[data-login-show]', page).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.dataset.loginShow;
          views.forEach(function (v) { v.hidden = v.dataset.loginView !== target; });
          // Skip the hidden form_type / utf8 inputs Shopify's form tag puts first.
          var toFocus = qs('[data-login-view="' + target + '"] input:not([type="hidden"])', page);
          if (toFocus) toFocus.focus();
        });
      });
    });
  }

  /* ---------------------------------------------------------------------------
     Sign-in / create account: show-hide password + a loading state on submit
     (snippets/auth-field.liquid, sections/main-login & main-register)
     ------------------------------------------------------------------------ */
  function initAuthForms(ctx) {
    qsa('[data-password-toggle]', ctx).forEach(function (btn) {
      if (!once(btn, 'PwToggle')) return;
      var input = document.getElementById(btn.getAttribute('aria-controls'));
      if (!input) return;
      btn.addEventListener('click', function () {
        var show = input.type === 'password';
        input.type = show ? 'text' : 'password';
        btn.classList.toggle('is-visible', show);
        btn.setAttribute('aria-pressed', String(show));
        btn.setAttribute('aria-label', show ? btn.dataset.labelHide : btn.dataset.labelShow);
        input.focus({ preventScroll: true });
      });
    });
    // `submit` only fires once native validation passes, so the spinner never shows on an invalid form.
    qsa('[data-auth] form', ctx).forEach(function (form) {
      if (!once(form, 'AuthForm')) return;
      form.addEventListener('submit', function () {
        var btn = qs('.auth__submit', form);
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      });
    });
  }
  // Coming back via the back button restores the page from cache — clear any spinner left on it.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    qsa('.auth__submit.is-loading').forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
  });

  /* ---------------------------------------------------------------------------
     12. Init + theme editor events
     ------------------------------------------------------------------------ */
  function safeInit(fn, label) {
    try { fn(); } catch (e) { if (window.console) console.warn('[Furniselan] init error in ' + label + ':', e); }
  }

  function initAll(ctx) {
    safeInit(function () { Overlay.init(); }, 'Overlay.init');
    safeInit(function () { initRotors(ctx); }, 'initRotors');
    safeInit(function () { initRails(ctx); }, 'initRails');
    safeInit(function () { initHero(ctx); }, 'initHero');
    safeInit(function () { initPromoLine(ctx); }, 'initPromoLine');
    safeInit(function () { initCategoryTabs(ctx); }, 'initCategoryTabs');
    safeInit(function () { initProductTabs(ctx); }, 'initProductTabs');
    safeInit(function () { initHeader(ctx); }, 'initHeader');
    safeInit(function () { initSearch(ctx); }, 'initSearch');
    safeInit(function () { initPincode(ctx); }, 'initPincode');
    safeInit(function () { FS.initQuickView(ctx); }, 'initQuickView');
    safeInit(function () { FS.initCart(ctx); }, 'initCart');
    safeInit(function () { initHelp(ctx); }, 'initHelp');
    safeInit(function () { initVideoCards(ctx); }, 'initVideoCards');
    safeInit(function () { initReels(ctx); }, 'initReels');
    safeInit(function () { initForms(ctx); }, 'initForms');
    safeInit(function () { if (FS.initProductGallery) FS.initProductGallery(ctx); }, 'initProductGallery');
    safeInit(function () { if (FS.initCollection) FS.initCollection(ctx); }, 'initCollection');
    safeInit(function () { FS.initProductForm(ctx); }, 'initProductForm');
    safeInit(function () { if (FS.initVariantSelector) FS.initVariantSelector(ctx); }, 'initVariantSelector');
    safeInit(function () { FS.initProductCardSwatches(ctx); }, 'initProductCardSwatches');
    safeInit(function () { if (FS.initProductCardSliders) FS.initProductCardSliders(ctx); }, 'initProductCardSliders');
    safeInit(function () { if (FS.initVariantPopup) FS.initVariantPopup(ctx); }, 'initVariantPopup');
    safeInit(function () { if (FS.initWishlist) FS.initWishlist(ctx); }, 'initWishlist');
    safeInit(function () { FS.initLiveShop(ctx); }, 'initLiveShop');
    safeInit(function () { initLogin(ctx); }, 'initLogin');
    safeInit(function () { initAuthForms(ctx); }, 'initAuthForms');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var drawer = qs('[data-cart-drawer]', e.target); if (drawer) Overlay.show(drawer);
    var pin = qs('[data-pin-modal]', e.target); if (pin) Overlay.show(pin);
    var search = qs('[data-search-modal]', e.target); if (search) { Overlay.show(search); if (search._searchOpen) search._searchOpen(); }
    var help = qs('[data-help-panel]', e.target); if (help) help.hidden = false;

  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var drawer = qs('[data-cart-drawer]', e.target); if (drawer) Overlay.hide(drawer);
    var pin = qs('[data-pin-modal]', e.target); if (pin) Overlay.hide(pin);
    var search = qs('[data-search-modal]', e.target); if (search) Overlay.hide(search);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.hero-slide');
    if (slide) slide.closest('[data-hero-slider]').dispatchEvent(new CustomEvent('fs:block-select', { detail: slide }));
    var rail = e.target.closest('.rail');
    if (rail) e.target.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
    var panel = e.target.closest('.product-panel');
    if (panel) { var tab = qs('.tab[data-panel="' + panel.dataset.panel + '"]', panel.closest('[data-product-tabs]')); if (tab) tab.click(); }

    var mega = e.target.closest('.mega-menu');
    var megaHeader = mega && mega.closest('[data-site-header]');
    if (megaHeader && megaHeader._openMega) megaHeader._openMega(mega.id);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var mega = e.target.closest('.mega-menu');
    var megaHeader = mega && mega.closest('[data-site-header]');
    if (megaHeader && megaHeader._closeMega) megaHeader._closeMega();
  });

  window.Furniselan = { cart: FS.Cart, quickView: FS.QuickView, formatMoney: formatMoney, loadScriptOnce: loadScriptOnce, overlay: Overlay, init: initAll };
})();